<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      Готовность {{ doneCount }}/{{ items.length }}
    </v-card-title>
    <v-card-text>
      <div
        v-for="item in items"
        :key="item.key"
        class="d-flex align-center mb-2"
      >
        <v-icon :color="item.done ? 'success' : 'error'" class="mr-3">
          {{ item.done ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
        <span :class="item.done ? '' : 'error--text'">{{ item.title }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'FilialConnectionReadinessChecklist',
    props: {
      items: { type: Array, default: () => [] },
    },
    computed: {
      doneCount () {
        return this.items.filter((item) => item.done).length
      },
    },
  }
</script>
